import produce from 'immer';
export var getInitialState = function () { return ({
    loading: false,
    updating: false,
    error: false,
    variables: [],
    files: [],
    filesMeta: {},
}); };
function variablesReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_VARIABLES_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'LOAD_VARIABLES_SUCCESS':
                state.loading = false;
                state.error = false;
                state.variables = action.variables || [];
                break;
            case 'LOAD_VARIABLES_FAILURE':
                state.loading = false;
                state.error = true;
                state.variables = [];
                break;
            case 'CREATE_VARIABLE_REQUEST':
            case 'UPDATE_VARIABLE_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'CREATE_VARIABLE_SUCCESS':
            case 'UPDATE_VARIABLE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.variables = action.variables || [];
                break;
            case 'CREATE_VARIABLE_FAILURE':
            case 'UPDATE_VARIABLE_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'DELETE_VARIABLE_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'DELETE_VARIABLE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.variables = state.variables.filter(function (l) { return l.id !== action.variableId; });
                break;
            case 'DELETE_VARIABLE_FAILURE':
                state.loading = false;
                state.error = action.error;
                break;
            case 'STATE_LOAD_FILES_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'STATE_LOAD_FILES_SUCCESS':
                state.files = action.files || [];
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case 'STATE_LOAD_FILES_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default variablesReducer;
